/* FASVENA - Complete the look rails (2026-10-06, Designer). Loaded (deferred) by snippets/fasvena-ea-complete-look.liquid.
   Progressive enhancement only: without this file the rails still scroll by touch, trackpad and keyboard (the rail is focusable).
   What it does: shows the two arrow buttons of a row only when that row has more cards than fit, moves one card per click, and
   disables the arrow at either end. Direction-agnostic (works in RTL: the sign comes from the computed direction). Honours reduced
   motion (no smooth scroll). Does not touch the product cards: their colour circles, size dropdown and Add are initialised by the
   theme's own initPick. */
(function () {
  'use strict';
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function setup(group) {
    if (group.__fveaLook) return;
    var rail = group.querySelector('[data-fvea-look-rail]');
    var nav = group.querySelector('[data-fvea-look-nav]');
    if (!rail || !nav) return;
    group.__fveaLook = true;
    var prev = nav.querySelector('[data-fvea-look-step="-1"]');
    var next = nav.querySelector('[data-fvea-look-step="1"]');

    function sign() { return getComputedStyle(rail).direction === 'rtl' ? -1 : 1; }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var pos = Math.abs(rail.scrollLeft);
      nav.hidden = max <= 2;
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max - 2;
    }
    function step(dir) {
      var item = rail.querySelector('.fvea-look__item');
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      var w = item ? item.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      rail.scrollBy({ left: dir * sign() * w, behavior: reduced() ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(rail); else window.addEventListener('resize', update);
    update();
  }

  function init(root) { (root || document).querySelectorAll('[data-fvea-look-group]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });   /* theme editor */
})();
